import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { navPerformanceNow } from '~/utilities/navigationTiming';

export default function useTrackHeroPerformance() {
  const { trackEvent } = useContext(AnalyticsContext);

  useEffectOnce(() => {
    trackEvent('Home Hero Load Time', {
      loadTime: navPerformanceNow()
    });
  }, [trackEvent]);
}
